import React from 'react';
import BillPdf from './BillPdf';
import ThermalBillPdf from './ThermalBillPdf';
import ReviewBillPdf from './ReviewBillPdf';

const BillTemplateRenderer = ({ selectedTemplate, billData, branchData, printRef }) => {
  // Extract common functions that all templates might need
  const capitalizeWords = (inputString) => {
    let words = inputString.split(' ');
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(' ');
  };

  // Prepare common props for all templates
  const commonProps = {
    data: billData,
    branchData,
    printRef,
    helpers: {
      capitalizeWords
    }
  };

  switch(selectedTemplate) {
    case 3:
      return <ThermalBillPdf {...commonProps} />;
    case 2:
      return <ReviewBillPdf {...commonProps} />;
    case 1:
    default:
      return <BillPdf {...commonProps} />;
  }
};

export default BillTemplateRenderer;